import axios from '@/utils/request'

const ApiUrl = '/admin_api/v1/product'
export function getList(params) {
  return axios.get(`${ApiUrl}/price_list/`, {
    params: { is_manual_order: 0, ...params }
  })
}

export function del(product_id) {
  return axios.delete(`${ApiUrl}/price/${product_id}/delete/`)
}

export function getDetail(product_id) {
  return axios.get(`${ApiUrl}/price/${product_id}/`)
}

export function add(data) {
  return axios.post(`${ApiUrl}/price_create/`, data)
}

export function edit(product_id, data) {
  return axios.put(`${ApiUrl}/price/${product_id}/`, data)
}
